import { BEMS_COMPONENT, BEMS_COMPONENT_SEPARATOR, BEMS_ELEMENT_SEPARATOR, BEMS_MODIFIER_SEPARATOR, BEMS_WHEN_SEPARATOR } from '../../_common/constants';

const bem = (b, e, m, s, c = BEMS_COMPONENT) => {
  const block = c + BEMS_COMPONENT_SEPARATOR + b;
  const element = e ? BEMS_ELEMENT_SEPARATOR + e : '';
  const modifier = m ? BEMS_MODIFIER_SEPARATOR + m : '';
  const state = s ? BEMS_WHEN_SEPARATOR + s : '';
  return b ? `${block}${element}${modifier} ${state}` : state;
};

export default bem;
